import { api } from 'redux-store/api';

import { IGeolocation } from './';

export const geolocationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGeolocation: build.query<IGeolocation | undefined, void>({
      queryFn: async () => {
        try {
          const apiKey = process.env.REACT_APP_IPAPI_KEY || '';
          const url = new URL('https://ipapi.co/json/');
          if (apiKey) {
            url.searchParams.set('key', apiKey);
          }

          const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
              Accept: 'application/json',
            },
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          return { data };
        } catch (error) {
          // Silently fail - geolocation is optional and shouldn't break the app
          console.warn('Geolocation service unavailable:', error);
          return { data: undefined };
        }
      },
      // Retry configuration - only retry once to avoid delays
      extraOptions: {
        maxRetries: 1,
      },
    }),
  }),
});

export const { useGetGeolocationQuery, useLazyGetGeolocationQuery } = geolocationApi;
